export default function PageHeader({ title, subtitle, action }) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <div className="label-eyebrow">HACCP Record</div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight mt-1">
          {title}
        </h1>
        {subtitle && <p className="text-charcoal-soft mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </header>
  );
}
